export default __webpack_public_path__ + "static/media/unlock-icon.118dd9d7.svg";